export function getCurrentPriceUnit(prices, units, priceInDebt, unitsLeftAsNormalPrice = Infinity) {
    if (!prices || prices.length === 0) return null
    if (units <= unitsLeftAsNormalPrice) return prices[Math.min(Math.max(units - 1, 0), prices.length - 1)]
    return priceInDebt
}
export function getNextPriceUnit(prices, units, priceInDebt, unitsLeftAsNormalPrice) {
    return getCurrentPriceUnit(prices, units + 1, priceInDebt, unitsLeftAsNormalPrice)
}
export function getTotalPrice(prices, units, priceInDebt, unitsLeftAsNormalPrice = Infinity) {
    if (units <= 0) return 0
    if (units <= unitsLeftAsNormalPrice) return units * getCurrentPriceUnit(prices, units)
    return ((units - unitsLeftAsNormalPrice) * priceInDebt) + getTotalPrice(prices, unitsLeftAsNormalPrice)
}
// export function getTotalPrice(prices, units, accumulate = 0) {
//     if (units === 0) {
//         return 0
//     }
//     return accumulate + prices[0] + getTotalPrice(prices.length > 1 ? prices.slice(1) : prices, units - 1)
// }



// WEBPACK FOOTER //
// src/utils/prices.js